import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute, Navigation, Router } from '@angular/router';
import { SharedDataService } from 'src/app/services/shared-data.service';

@Component({
  selector: 'app-client-admin',
  templateUrl: './client-admin.component.html',
  styleUrls: ['./client-admin.component.less'],
  providers: [SharedDataService],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ClientAdminComponent {
  constructor(
    private Router: Router,
    private SharedDataService: SharedDataService
  ) {
    this.NavigationData = this.Router.currentNavigation();

    if (this.NavigationData) {
      // This is just a parent component container. This is the default route when the admin
      // menu item is clicked on.
      // this.Router.navigate(['my-company'], { relativeTo: this.route });
    }

    this.SharedDataService.listenForEvent().subscribe({
      next: ({ eventName, data }) => {
        if (eventName === 'GetNavigationData') {
          this.SharedDataService.sendEvent(
            'SetNavigationData',
            this.NavigationData
          );
        }
      }
    });
  }

  title = 'Admin';
  NavigationData: Navigation | null;
}
